import React, { FC, useCallback, useState } from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { Category } from 'shared/types/product/Category';
import Button from 'components/commercetools-ui/atoms/button';
import Drawer from 'components/commercetools-ui/atoms/drawer';
import { useFormat } from 'helpers/hooks/useFormat';
import { Reference } from 'types/reference';
import { ImageProps } from 'frontastic/lib/image';
import MobileMenu from './content/mobile-menu';
import MobileMenuFooter from './content/mobile-menu-footer';
import MobileMenuHeader from './content/mobile-menu-header';
import debounce from 'lodash.debounce';

export interface Props {
  logo: ImageProps;
  logoLink: string;
  links: Category[];
  topRightMenu: any;
  topCentreMenu: any;
  showSearchBar?: boolean;
  setShowSearchBar?: any;
}

const HeaderNavigationMobile: FC<Props> = ({
  links,
  topRightMenu,
  topCentreMenu,
  logo,
  logoLink,
  showSearchBar,
  setShowSearchBar,
}) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const [categoriesNavigator, setCategoriesNavigator] = useState<Category[]>([]);
  const [showMenu, setShowMenu] = useState(false);

  const showHeaderMenu = () => {
    setShowMenu(true);
  };

  const hideHeaderMenu = useCallback(
    debounce(() => {
      setShowMenu(false);
      setCategoriesNavigator([]);
    }, 250),
    [],
  );
  const removeCategory = () => {
    setCategoriesNavigator((array) => array.slice(0, -1));
  };

  const insertCategory = (category: Category) => {
    setCategoriesNavigator((array) => [...array, category]);
  };

  return (
    <div className="flex lg:hidden">
      <Button
        variant="ghost"
        size="fit"
        onClick={showHeaderMenu}
        title={formatMessage({ id: 'header.menu.open', defaultMessage: 'Open side menu' })}
        className="mr-8"
      >
        <Bars3Icon className="w-24 text-secondary-black lg:w-48" />
      </Button>

      <Drawer
        isOpen={showMenu}
        direction="left"
        className="w-full border border-neutral-400 bg-neutral-100"
        onClose={hideHeaderMenu}
      >
        <MobileMenuHeader
          categories={categoriesNavigator}
          hideHeaderMenu={hideHeaderMenu}
          logo={logo}
          logoLink={logoLink}
          onArrowClick={removeCategory}
          showSearchBar={showSearchBar}
          setShowSearchBar={setShowSearchBar}
        />

        <MobileMenu
          links={links}
          topRightMenu={topRightMenu}
          topCentreMenu={topCentreMenu}
          hideHeaderMenu={hideHeaderMenu}
          categoriesNavigator={categoriesNavigator}
          onArrowClick={removeCategory}
          insertCategory={insertCategory}
        />

        <MobileMenuFooter showMenu={showMenu} hideHeaderMenu={hideHeaderMenu} insertCategory={insertCategory} />
      </Drawer>
    </div>
  );
};

export default HeaderNavigationMobile;
